/* eslint-disable */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Checkbox,
  FormControlLabel,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';
import { Field } from 'formik';
import { FormattedPhone } from 'components/Shared/FormattedPhone';
import FormikTextField from 'components/FormikFields/FormikTextField';
import cx from 'classnames';
import SendingOptions from './widgets/SendingOptions/SendingOptions';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(1, 0, 0, 0),
  },
  contentArea: {
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingBottom: theme.spacing(1),
  },
  headerSection: {
    textAlign: 'center',
    // marginBottom: theme.spacing(4),
    // padding: theme.spacing(2, 0),
  },
  secondaryTitle: {
    fontSize: 16,
    fontWeight: 500,
    color: '#718096',
    lineHeight: 1.5,
    marginBottom: theme.spacing(1),
  },
  formCard: {
    backgroundColor: 'white',
    borderRadius: 16,
    padding: theme.spacing(2, 2.5),
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
    border: '1px solid rgba(0, 0, 0, 0.06)',
    marginBottom: theme.spacing(2),
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: 600,
    color: '#2d3748',
    marginBottom: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  fieldGroup: {
    marginBottom: theme.spacing(2),
  },
  fieldWithCheckbox: {
    position: 'relative',
  },
  checkboxWrapper: {
    marginTop: theme.spacing(1),
    transition: 'all 0.3s ease',
    overflow: 'hidden',
  },
  hideCheckbox: {
    maxHeight: 0,
    opacity: 0,
    marginTop: 0,
  },
  showCheckbox: {
    maxHeight: 80,
    opacity: 1,
    marginTop: theme.spacing(1),
  },
  checkboxCard: {
    backgroundColor: '#f0f2ff',
    borderRadius: 12,
    padding: theme.spacing(1.5, 2),
    border: '1px solid rgba(0, 168, 255, 0.2)',
  },
  checkbox: {
    color: '#00A8FF',
    '&.Mui-checked': {
      color: '#00A8FF',
    },
  },
  checkboxLabel: {
    fontSize: 14,
    fontWeight: 500,
    color: '#2d3748',
    '& .MuiFormControlLabel-label': {
      fontSize: 14,
    },
  },
  formError: {
    textAlign: 'center',
    padding: theme.spacing(2),
    backgroundColor: '#fed7d7',
    borderRadius: 12,
    border: '1px solid #f56565',
    marginTop: theme.spacing(2),
  },
  errorText: {
    color: '#c53030',
    fontSize: 14,
    fontWeight: 500,
  },
  actionsContainer: {
    padding: theme.spacing(2, 0, 0, 0),
    borderTop: '1px solid rgba(0, 0, 0, 0.06)',
    flexShrink: 0,
  },
}));

const AssessmentForm = ({
                          backendErrors,
                          setBackendErrors,
                          actions,
                          subtitle,
                          values,
                          initialValues,
                          hideSendingOptions,
                          patientUUID,
                          accountUuid,
                        }) => {
  const classes = useStyles();
  const { en: { forms } } = useSelector((state) => state.i18n);

  const [hasEmailDiff, setHasEmailDiff] = useState(
    values.email !== initialValues.email && values.email,
  );
  const [hasPhoneDiff, setHasPhoneDiff] = useState(
    values.phone !== initialValues.phone && values.phone,
  );

  useEffect(() => {
    setHasEmailDiff(values.email !== initialValues.email && values.email);
    setHasPhoneDiff(values.phone !== initialValues.phone && values.phone);
  }, [values.email, values.phone]);

  return (
    <div className={classes.container}>
      <div className={classes.contentArea}>
        <div className={classes.headerSection}>
          <Typography className={classes.secondaryTitle}>{subtitle}</Typography>
        </div>

        <div className={classes.formCard}>
          <Typography className={classes.sectionTitle}>
            📧 Contact Information
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} md={hideSendingOptions ? 8 : 6}>
              <div className={classes.fieldGroup}>
                <div className={classes.fieldWithCheckbox}>
                  <FormikTextField
                    type='text'
                    name='email'
                    label={forms.email}
                    backendError={
                      backendErrors && (backendErrors.email ||
                        backendErrors.Email ||
                        backendErrors.sendInviteToPatientEmail ||
                        (backendErrors[''] && ' '))
                    }
                  />
                  <div
                    className={cx(classes.checkboxWrapper, classes.hideCheckbox, {
                      [classes.showCheckbox]: hasEmailDiff,
                    })}
                  >
                    <div className={classes.checkboxCard}>
                      <Field name='updatePatientRecordEmail' type='checkbox'>
                        {({ field, form }) => (
                          <FormControlLabel
                            control={
                              <Checkbox
                                name={field.name}
                                checked={field.value}
                                className={classes.checkbox}
                                onChange={(e, checked) => {
                                  form.setFieldValue(field.name, checked);
                                }}
                                disabled={!hasEmailDiff}
                              />
                            }
                            className={classes.checkboxLabel}
                            label={forms.updatePatientRecordEmail}
                          />
                        )}
                      </Field>
                    </div>
                  </div>
                </div>
              </div>

              <div className={classes.fieldGroup}>
                <div className={classes.fieldWithCheckbox}>
                  <FormikTextField
                    type='tel'
                    name='phone'
                    label={forms.phone}
                    backendError={
                      backendErrors && (backendErrors.phone ||
                        backendErrors.Phone ||
                        backendErrors.sendInviteToPatientPhone ||
                        (backendErrors[''] && ' '))
                    }
                    InputProps={{
                      inputComponent: FormattedPhone,
                    }}
                  />
                  <div
                    className={cx(classes.checkboxWrapper, classes.hideCheckbox, {
                      [classes.showCheckbox]: hasPhoneDiff,
                    })}
                  >
                    <div className={classes.checkboxCard}>
                      <Field name='updatePatientRecordPhone' type='checkbox'>
                        {({ field, form }) => (
                          <FormControlLabel
                            control={
                              <Checkbox
                                name={field.name}
                                checked={field.value}
                                className={classes.checkbox}
                                onChange={(e, checked) => {
                                  form.setFieldValue(field.name, checked);
                                }}
                                disabled={!hasPhoneDiff}
                              />
                            }
                            className={classes.checkboxLabel}
                            label={forms.updatePatientRecordPhone}
                          />
                        )}
                      </Field>
                    </div>
                  </div>
                </div>
              </div>
            </Grid>

            {!hideSendingOptions && (
              <Grid item xs={12} md={6}>
                <SendingOptions
                  backendErrors={backendErrors}
                  setBackendErrors={setBackendErrors}
                  initialValues={initialValues}
                  values={values}
                  patientUUID={patientUUID}
                  accountUuid={accountUuid}
                />
              </Grid>
            )}
          </Grid>

          {backendErrors && backendErrors[''] && (
            <div className={classes.formError}>
              <Typography className={classes.errorText}>
                {backendErrors['']}
              </Typography>
            </div>
          )}
        </div>
      </div>

      <div className={classes.actionsContainer}>
        {actions}
      </div>
    </div>
  );
};

AssessmentForm.propTypes = {
  subtitle: PropTypes.string.isRequired,
  actions: PropTypes.node,
  hideSendingOptions: PropTypes.bool,
  values: PropTypes.shape({
    phone: PropTypes.string,
    email: PropTypes.string,
  }).isRequired,
  initialValues: PropTypes.shape({
    phone: PropTypes.string,
    email: PropTypes.string,
  }).isRequired,
  backendErrors: PropTypes.shape({
    email: PropTypes.string,
    Email: PropTypes.string,
    phone: PropTypes.string,
    Phone: PropTypes.string,
    sendInviteToPatientEmail: PropTypes.string,
    sendInviteToPatientPhone: PropTypes.string,
    sendingDataError: PropTypes.string,
  }),
};

AssessmentForm.defaultProps = {
  actions: undefined,
  backendErrors: undefined,
  hideSendingOptions: false,
};

export default AssessmentForm;
